let element = document.getElementById('js-opportunities');
let filters = JSON.parse(element?.getAttribute('data-filters') ?? '{}');
let api = element?.getAttribute('data-opportunities-api') ?? '';

var information = {
	filters,
	api
};

export default information;